import { ClientSponsor, Feature } from '@ats/api/cm';
import { gql } from 'apollo-angular';

export interface ClientFeatureResponse extends Pick<ClientSponsor, 'name'> {
	features: Pick<Feature, 'id' | 'enabled' | 'key'>[];
}

export const ActiveClientFeaturesQuery = gql`
	query ipActiveClientFeatures($request: ClientFeatureListRequest) {
		clientSponsor {
			name
			features(request: $request) {
				id
				enabled
				key
			}
		}
	}
`;
